import { Dropdown, Image, Menu, MenuProps } from "antd";
import PolygonDropdownIcon from "../../../../../assets/icons/PolygonDropdownIcon";
import Avatar from "../../../../../assets/images/avatar.svg";
import { formatDate, formatTime } from "../../../../../lib/time";
import { SingleMail } from "../../../../../types/mail";
type Props = {
  email: SingleMail;
};

const EmailHeader = ({ email }: Props) => {
  const items: MenuProps["items"] = [
    {
      label: <DropDownLabel email={email} title="from:" type="from" />,
      key: "0",
    },
    {
      label: <DropDownLabel email={email} title="to:" type="to" />,
      key: "1",
    },
    ...(email?.cc_users?.length
      ? [
          {
            label: <DropDownLabel email={email} title="cc:" type="cc" />,
            key: "2",
          },
        ]
      : []),
    ...(email?.bcc_users?.length
      ? [
          {
            label: <DropDownLabel email={email} title="bcc:" type="bcc" />,
            key: "3",
          },
        ]
      : []),
    {
      label: <DropDownLabel email={email} title="date:" type="date" />,
      key: "4",
    },
    {
      label: <DropDownLabel email={email} title="subject:" type="subject" />,
      key: "5",
    },
  ];

  return (
    <div>
      <div className="flex items-center gap-4 text-sm">
        <div>
          <Image
            src={email.sender?.personalInfo?.pro_pic || Avatar}
            preview={false}
            alt={"User Profile"}
            width={56}
            height={56}
            className="rounded-full"
          />
        </div>
        <div>
          <div className="flex items-start gap-1 mb-2">
            <span className="text-[22px] text-[#2D3643]">
              {email?.sender?.officialInfo?.name}
            </span>{" "}
            <span className="text-sm text-[#5E718D]">
              &lt;{email?.sender?.officialInfo?.email}
              &gt;
            </span>
          </div>

          <div className="flex justify-start items-center gap-2 text-sm text-body-text">
            <span>To</span>

            <Dropdown
              className="cursor-pointer"
              trigger={["click"]}
              dropdownRender={() => (
                <div
                  style={{
                    width: 450,
                  }}
                >
                  <Menu items={items} />
                </div>
              )}
            >
              <div onClick={(e) => e.preventDefault()}>
                <PolygonDropdownIcon />
              </div>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

type DropdownLabelProps = {
  email: SingleMail;
  title: string;
  type: "bcc" | "cc" | "from" | "to" | "date" | "subject";
};
const DropDownLabel = ({ email, type, title }: DropdownLabelProps) => {
  const renderLabelContent = () => {
    switch (type) {
      case "from":
        return (
          <div className="text-left text-slate-700 text-base font-normal">
            <span className="text-zinc-700 text-base font-medium">
              {email?.sender?.officialInfo?.name}
            </span>{" "}
            &lt;{email?.sender?.officialInfo?.email}&gt;
          </div>
        );
      case "to":
        return (
          <div className="text-left text-slate-700 text-base font-normal">
            <span className="text-zinc-700 text-base font-normal">
              {email?.receiver?.officialInfo?.name}
            </span>{" "}
            &lt;{email?.receiver?.officialInfo?.email}&gt;
          </div>
        );
      case "cc":
        return (
          <div className="text-left text-slate-700 text-base font-normal">
            {email.cc_users.map((user: any, index: number) => (
              <>
                <div key={index}>
                  <span className="text-zinc-700 text-base font-normal">
                    {user?.officialInfo?.name}
                  </span>{" "}
                  &lt;{user?.officialInfo?.email}&gt;{" "}
                  {email?.cc_users?.length > 1 && <>,</>}
                </div>
              </>
            ))}
          </div>
        );
      case "bcc":
        return (
          <div className="text-left text-slate-700 text-base font-normal">
            {email.bcc_users.map((user: any, index: number) => (
              <>
                <div key={index}>
                  <span className="text-zinc-700 text-base font-normal">
                    {user?.officialInfo?.name}
                  </span>{" "}
                  &lt;{user?.officialInfo?.email}&gt;{" "}
                  {email?.bcc_users?.length > 1 && <>,</>}
                </div>
              </>
            ))}
          </div>
        );
      case "date":
        return (
          <div className="text-left text-slate-700 text-base font-normal">
            {formatDate(email?.created_at ?? "")},{" "}
            {formatTime(email?.created_at ?? "")}
          </div>
        );
      case "subject":
        return (
          <div className="text-left text-slate-700 text-base font-normal">
            {email?.subject}
          </div>
        );
      default:
        return <></>;
    }
  };
  return (
    <div className="grid grid-cols-[20%_80%] gap-2">
      <div className="text-right text-slate-700 text-base font-normal">
        {title}
      </div>
      {renderLabelContent()}
    </div>
  );
};

export default EmailHeader;
